import { Box, BoxProps, Collapse, Divider } from '@chakra-ui/react';
import { useState, ReactNode } from 'react';
import { EditIcon } from 'ui/icons/Icons';
import IconButton from 'ui/molecules/IconButton';

type Props = {
  divider?: boolean;
  collapsedContent?: ReactNode;
  allowEdition?: boolean;
};

const SummaryListItem = ({
  children,
  divider,
  // collapseIcon,
  collapsedContent,
  allowEdition,
  ...props
}: Props & BoxProps) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);
  return (
    <Box width="full" borderRadius="10px" padding="2" {...props}>
      <Box
        width="full"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        {children}
        {allowEdition && (
          <IconButton
            right="0"
            aria-label="edit"
            boxSize={42}
            icon={
              <Box color="primaryColor">
                <EditIcon boxSize={10} />
              </Box>
            }
            onClick={() => {
              setIsEditing(!isEditing);
            }}
          />
        )}
      </Box>
      {collapsedContent && (
        <Collapse in={isEditing}>
          <Box p="5">{collapsedContent}</Box>
        </Collapse>
      )}

      {divider && <Divider paddingBottom="3" />}
    </Box>
  );
};

export default SummaryListItem;
